<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card body-class="p-0">
          <template v-slot:body>
            <div class="iq-edit-list">
              <tab-nav :pills="true" class="iq-edit-profile d-flex">
                <tab-nav-items
                  class="col-md-6 p-0"
                  :active="true"
                  href="#planning"
                  title="SHIPMENT PLANNING"
                  @click="activeTab = 'planning'"
                />
                <tab-nav-items
                  class="col-md-6 p-0"
                  :active="false"
                  href="#realisasi"
                  title="RUNNING SHIPMENT"
                  @click="activeTab = 'realisasi'"
                />
                <!-- <tab-nav-items
                  class="col-md-4 p-0"
                  :active="false"
                  href="#report"
                  title="REPORT"
                  @click="activeTab = 'report'"
                /> -->
              </tab-nav>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <template v-if="activeTab == 'planning'">
          <TabShipmentPlanningNew />
        </template>
        <template v-if="activeTab == 'realisasi'">
          <TabRunningShipment />
        </template>
        <template v-if="activeTab == 'report'">
          <TabReport />
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import _ from 'lodash'
import TabRealisasi from './TabRealisasi.vue'
import TabReport from './TabReport.vue'
import TabShipmentPlanningNew from './TabShipmentPlanningNew.vue'
import TabRunningShipment from './TabRunningShipment.vue'

export default {
  name: 'BusdevDashboardNew',
  data() {
    return {
      activeTab: 'planning',
    }
  },
  mounted() {},
  components: {
    TabShipmentPlanningNew,
    TabReport,
    TabRealisasi,
    TabRunningShipment,
  },
  methods: {},
}
</script>
